export enum SitemapStatus {
  EXCLUDE = 'exclude',
}
